module.exports = __webpack_public_path__ + "static/img/case2.d43314cd.png";